"use strict";
// import {
//   BadgeControl,
//   ButtonControl,
//   CheckboxControl,
//   CircularLoaderControl,
//   DividerControl,
//   LabelControl,
//   TextInputControl,
//   Utilities,
// } from "doshx_controls_web";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { auctions_for_client } from "../../../api/calls/auction/auctions_for_client";
// import { register_for_auctions } from "../../../api/calls/auction/register_for_auctions";
// import { parseJwt } from "../../../helpers/parseJwt";
// import { setDrawer, setMessageModal } from "../../../reducers/slices/main";
// import { ContainerControl } from "../../../controls/container";
// import { useNavigate } from "react-router-dom";
// import { AUCTION_COMPLETE_ROUTE, AUCTION_DETAILS_ROUTE, AUCTION_LIVE_ROUTE, LIVE_ROUTE } from "../../../constants/routes";
// import { setAuction } from "../../../reducers/slices/auction";
// import { BidderStatusComponent } from "../../../components/bidder_status";
// import { AuctionStatusTag } from "../../../components/tags/auction_status_tag";
// import { crossIcon } from "../../../../../assets/icons";
// import { bidder_status } from "../../../api/calls/bidder/bidder_status";
// import { AuctionRulesConditionsPage } from "../sign_up/auction_rules_conditions";
// import { LogInComponent } from "../login/login";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionsPage = void 0;
// export const AuctionsPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { user } = useSelector((state: any) => state.userState);
//   const { bid } = useSelector((state: any) => state.bidState);
//   // const { user, isLoading } = useSelector<any, IUserSliceState>((state: any) => state.userState);
//   const [auctions, setAuctions] = useState<any[]>([]);
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   const [selectedAuctionId, setSelectedAuctionId]:any = useState();
//   const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
//   const [paddleNumber, setPaddleNumber] = useState<string | null>(null);
//   const client_entity_id = parseJwt(process.env.CLIENT_TOKEN)?.entity_id;
//   useEffect(()=>{
//     const auctionResponse:any =  auctions_for_client({
//       entity_id: client_entity_id,
//       user_entity_id: user.entity_id || ""
//     }).then((res)=>{setAuctions(res?.content)})
//   },[user])
//   // useEffect(() => {
//   //   const fetchBidderStatusAndAuctions = async () => {
//   //     setIsLoading(true);
//   //     try {
//   //       // 1. Fetch bidder status first
//   //       const bidderStatusResponse = await bidder_status({
//   //         client_entity_id: client_entity_id,
//   //         user_entity_id: user.entity_id,
//   //         auction_entity_id: "auction 56"
//   //       });
//   //       const paddle = bidderStatusResponse?.content?.bidder?.paddle_number || null;
//   //       setPaddleNumber(paddle);
//   //       // 2. Then fetch auctions
//   //       const auctionResponse = await auctions_for_client({
//   //         entity_id: client_entity_id,
//   //         user_entity_id: user?.entity_id,
//   //       });
//   //       if (auctionResponse.success) {
//   //         setAuctions(auctionResponse.content);
//   //       } else {
//   //         dispatch(
//   //           setMessageModal({
//   //             title: "Something went wrong!",
//   //             messages: [auctionResponse.message],
//   //           }),
//   //         );
//   //       }
//   //     } catch (error) {
//   //       console.error("Error loading data:", error);
//   //       dispatch(
//   //         setMessageModal({
//   //           title: "Error",
//   //           messages: ["Failed to load auctions or bidder status. Please try again."],
//   //         }),
//   //       );
//   //     } finally {
//   //       setIsLoading(false);
//   //     }
//   //   };
//   //   if (client_entity_id && user?.entity_id) {
//   //     fetchBidderStatusAndAuctions();
//   //   }
//   // }, [client_entity_id, user?.entity_id]);
//   const isFullScreenLoading = isLoading || loadingIndex !== null;
//   return (
//     <div className="">
//       {/* {isFullScreenLoading && (
//   <div className="fixed inset-0 z-50 bg-white bg-opacity-70 flex items-center justify-center">
//     <CircularLoaderControl size="large" />
//   </div>
// )} */}
//       <ContainerControl className="flex flex-col gap-8" loading={isFullScreenLoading}>
//         <BidderStatusComponent />
//         <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
//           {Array.isArray(auctions)&&auctions?.map((auction, index) => {
//             return (
//               <div
//                 key={`auction-${index}`}
//                 className="flex flex-col bg-white rounded-lg shadow-lg hover:scale-105 transition-all cursor-pointer"
//                 onClick={() => {
//                   switch (auction.status) {
//                     case "Complete":
//                       navigate(`${AUCTION_COMPLETE_ROUTE}/${auction.entity_id}`);
//                       return;
//                     case "In-Progress":
//                       navigate(`${AUCTION_LIVE_ROUTE}/${auction.entity_id}`);
//                       return;
//                     default:
//                       dispatch(setAuction(null)); //Reset the previous loaded auction.
//                       navigate(`${AUCTION_DETAILS_ROUTE}/${auction.entity_id}`);
//                       return;
//                   }
//                 }}
//               >
//                 <div className="aspect-square rounded-t-lg overflow-clip flex-none">
//                   <img src={auction.images ? auction.images[0]?.uploaded_file_url : ""} className="object-cover w-full h-full" />
//                 </div>
//                 <div className="p-4 flex-1">
//                   <LabelControl label={auction.title} bold size="large" textColor="text-black" />
//                   <LabelControl label={auction.description} size="medium" textColor="text-black" maxLines={"three"} />
//                 </div>
//                 <DividerControl />
//                 <div className="p-4 pt-0 flex justify-between items-center">
//                   <LabelControl label={Utilities.formatDateTime(auction.date_from, "YYYY-MM-DD")} size="small" textColor="text-black" />
//                   <AuctionStatusTag auctionStatus={auction.status} size="small" />
//                 </div>
//                 {auction?.status !== "Complete" && (
//                 <div className="flex justify-center px-4">
//                   <button
//                     className={`w-full max-w-[274px] min-h-[37px] rounded-full text-white mb-2 text-center ${
//                       auction.auction_registered ? "bg-gray-400 cursor-not-allowed" : "bg-[#F04F23]"
//                     }`}
//                     // onClick={(e) => handleRegister(e, index, auction.entity_id)}
//                     // disabled={loadingIndex === index || auction.auction_registered}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (auction.auction_registered) return;
//                       (user && user.entity_id) ? dispatch(
//                         setDrawer({
//                           open: true,
//                           // content: <RegisterBidderComponent />,
//                           content: <AuctionRulesConditionsPage auctionId={auction.entity_id}
//                            registered={auction.auction_registered}/>,
//                         }),
//                       ) :
//                       dispatch(
//                         setDrawer({
//                           open: true,
//                           content: (
//                             <div className="w-96">
//                               <LogInComponent />
//                             </div>
//                           ),
//                         }),
//                       );
//                     }}
//                     disabled={auction.auction_registered}
//                   >
//                     {auction.auction_registered ? "Registered" : "Register Now!"}
//                   </button>
//                 </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </ContainerControl>
//     </div>
//   );
// };
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var auctions_for_client_1 = require("../../../api/calls/auction/auctions_for_client");
var parseJwt_1 = require("../../../helpers/parseJwt");
var main_1 = require("../../../reducers/slices/main");
var auction_1 = require("../../../reducers/slices/auction");
var bidder_status_1 = require("../../../api/calls/bidder/bidder_status");
var auction_rules_conditions_1 = require("../sign_up/auction_rules_conditions");
var auction_status_tag_1 = require("../../../components/tags/auction_status_tag");
var doshx_controls_web_1 = require("doshx_controls_web");
var routes_1 = require("../../../constants/routes");
var container_1 = require("../../../controls/container");
var bidder_status_2 = require("../../../components/bidder_status");
var AuctionsPage = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)([]), auctions = _b[0], setAuctions = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)({}), bidderStatus = _d[0], setBidderStatus = _d[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var client_entity_id = (_a = (0, parseJwt_1.parseJwt)(process.env.CLIENT_TOKEN)) === null || _a === void 0 ? void 0 : _a.entity_id;
    // useEffect(() => {
    var fetchAuctions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, auctions_for_client_1.auctions_for_client)({
                            entity_id: client_entity_id,
                            user_entity_id: (user === null || user === void 0 ? void 0 : user.entity_id) || ""
                        })];
                case 2:
                    response = _a.sent();
                    if (response === null || response === void 0 ? void 0 : response.content) {
                        setAuctions(response.content);
                        if (user === null || user === void 0 ? void 0 : user.entity_id) {
                            response.content.forEach(function (auction) {
                                checkBidderStatus(auction.entity_id);
                            });
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Error",
                        messages: ["Failed to load auctions"]
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    //   fetchAuctions();
    // }, [user?.entity_id,client_entity_id, dispatch]);
    (0, react_1.useEffect)(function () {
        fetchAuctions();
    }, [user === null || user === void 0 ? void 0 : user.entity_id, client_entity_id, dispatch]);
    var shouldReloadAuctions = (0, react_redux_1.useSelector)(function (state) { return state.auctionState.shouldReloadAuctions; });
    (0, react_1.useEffect)(function () {
        if (shouldReloadAuctions) {
            fetchAuctions();
            dispatch((0, auction_1.setShouldReloadAuctions)(false));
        }
    }, [shouldReloadAuctions]);
    var checkBidderStatus = function (auctionId) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(user === null || user === void 0 ? void 0 : user.entity_id))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, bidder_status_1.bidder_status)({
                            client_entity_id: client_entity_id,
                            user_entity_id: user.entity_id,
                            auction_entity_id: auctionId
                        })];
                case 2:
                    response_1 = _a.sent();
                    if (response_1.success) {
                        setBidderStatus(function (prev) {
                            var _a;
                            var _b;
                            return (__assign(__assign({}, prev), (_a = {}, _a[auctionId] = {
                                isRegistered: response_1.content.is_registered,
                                isVerified: response_1.content.is_verified,
                                paddleNumber: (_b = response_1.content.bidder) === null || _b === void 0 ? void 0 : _b.paddle_number
                            }, _a)));
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error checking bidder status:", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderAuctionButton = function (auction) {
        if (auction.status === "Complete")
            return null;
        var status = bidderStatus[auction.entity_id];
        // if (!user?.entity_id) {
        //   return (
        //     <button
        //       className="bg-[#E53935] hover:underline w-full max-w-[274px] min-h-[37px] rounded-full text-white mb-2 text-center"
        //       onClick={(e) => {
        //         e.stopPropagation();
        //         dispatch(setDrawer({
        //           open: true,
        //           content: <LogInComponent />,
        //         }));
        //       }}
        //     >
        //        Register to Bid
        //     </button>
        //   );
        // }
        // if (!status) {
        //   return (
        //     <button
        //       className="bg-gray-400 w-full max-w-[274px] min-h-[37px] rounded-full text-white mb-2 text-center cursor-not-allowed"
        //       disabled
        //     >
        //       Loading...
        //     </button>
        //   );
        // }
        if (status === null || status === void 0 ? void 0 : status.isRegistered) {
            return (react_1.default.createElement("button", { className: "w-full max-w-[274px] min-h-[37px] rounded-full text-white mb-2 text-center ".concat(status.isVerified ? "bg-[#4CAF50]" : "bg-[#F04F23]", " cursor-not-allowed"), disabled: true }, status.isVerified
                ? "Verified to Bid (#".concat(status.paddleNumber, ")")
                : "Registration Pending"));
        }
        return (react_1.default.createElement("button", { className: "bg-[#E53935] w-full max-w-[274px] min-h-[37px] rounded-full text-white mb-2 text-center", onClick: function (e) {
                e.stopPropagation();
                dispatch((0, main_1.setDrawer)({
                    open: true,
                    content: react_1.default.createElement(auction_rules_conditions_1.AuctionRulesConditionsPage, { auctionId: auction.entity_id }),
                }));
            } }, "Register to Bid"));
    };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(container_1.ContainerControl, { className: "flex flex-col gap-8", loading: isLoading },
            react_1.default.createElement(bidder_status_2.BidderStatusComponent, null),
            react_1.default.createElement("div", { className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4" }, Array.isArray(auctions) && (auctions === null || auctions === void 0 ? void 0 : auctions.map(function (auction, index) {
                var _a, _b;
                return (react_1.default.createElement("div", { key: "auction-".concat(index), className: "flex flex-col bg-white rounded-lg shadow-lg hover:scale-105 transition-all cursor-pointer", onClick: function () {
                        switch (auction.status) {
                            case "Complete":
                                navigate("".concat(routes_1.AUCTION_COMPLETE_ROUTE, "/").concat(auction.entity_id));
                                break;
                            case "In-Progress":
                                navigate("".concat(routes_1.AUCTION_LIVE_ROUTE, "/").concat(auction.entity_id));
                                break;
                            default:
                                dispatch((0, auction_1.setAuction)(null));
                                navigate("".concat(routes_1.AUCTION_DETAILS_ROUTE, "/").concat(auction.entity_id));
                        }
                    } },
                    react_1.default.createElement("div", { className: "aspect-square rounded-t-lg overflow-clip flex-none" },
                        react_1.default.createElement("img", { src: ((_b = (_a = auction.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url) || "", className: "object-cover w-full h-full", alt: auction.title })),
                    react_1.default.createElement("div", { className: "p-4 flex-1" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: auction.title, bold: true, size: "large", textColor: "text-black" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: auction.description, size: "medium", textColor: "text-black", maxLines: "three" })),
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                    react_1.default.createElement("div", { className: "p-4 pt-0 flex justify-between items-center" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatDateTime(auction.date_from, "YYYY-MM-DD"), size: "small", textColor: "text-black" }),
                        react_1.default.createElement(auction_status_tag_1.AuctionStatusTag, { auctionStatus: auction.status, size: "small" })),
                    react_1.default.createElement("div", { className: "px-4" }, renderAuctionButton(auction))));
            }))))));
};
exports.AuctionsPage = AuctionsPage;
